module.exports = __webpack_public_path__ + "static/img/cooperation7.944991c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImgs/cooperation7.png
// module id = D8mO
// module chunks = 11